export default __webpack_public_path__ + "static/media/mexiroomies.dccb8303.png";